// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ei7a","type":"styles_type__j3Dqp","choices":"styles_choices__328Xz"};